import React from 'react';
import _ from 'lodash';
import { Stack } from '@mui/material';

import AccountForm from './accountsForm/AccountsForm';
import TabsContainer from '../generics/tabs/TabsContainer';
import AccountsProvider from './Context';

export const EmployeeDetails = props => {
  const [openedTabs, setOpenedTabs] = React.useState([]);
  const [currentTab, setCurrentTab] = React.useState(null);

  const handleAddNewTab = application => {
    const idExists = _.filter(openedTabs, tab => tab.id == application.id);
    if (!_.isEmpty(idExists)) {
      setCurrentTab(idExists[0].id);

      return null;
    }
    setOpenedTabs(current => [
      ...current,
      { id: application.id, name: `Uzytkownik ${application.id}` }
    ]);
    setCurrentTab(application.id);
  };

  const handleChangeTab = (e, id) => {
    setCurrentTab(id);
  };

  const handleRemoveTab = id => {
    setOpenedTabs(prev => prev.filter(tab => tab.id !== id));
    setCurrentTab(null);
  };

  return (
    <Stack>
      <TabsContainer
        tabs={openedTabs}
        handleChangeTab={handleChangeTab}
        currentTab={currentTab}
        setCurrentTab={setCurrentTab}
        handleRemoveTab={handleRemoveTab}
      />
      {currentTab === null ? (
        <AccountForm handleAddNewTab={handleAddNewTab} />
      ) : (
        <AccountsProvider applicationId={currentTab}>
          <AccountForm />
        </AccountsProvider>
      )}
    </Stack>
  );
};
